export default "__VITE_ASSET__70ec3842__"